/**
 * Module-level mirror of the `enable_offline_checks` flag for code paths
 * that run outside React (e.g. axios interceptors). React components read
 * the flag from `useConfig()` and call `setOfflineFeatureEnabled()` to
 * keep this mirror in sync; everyone else reads via
 * `getOfflineFeatureEnabled()`.
 *
 * Default is `false`, matching the design's "no tenant silently opts in"
 * contract: until React has rendered and pushed the current tenant's
 * config, the flag is off.
 */

let enabled = false;

export function setOfflineFeatureEnabled(value: boolean): void {
    enabled = value;
}

export function getOfflineFeatureEnabled(): boolean {
    return enabled;
}

/** For tests only. Reset to the default. */
export function _resetOfflineFeatureFlagForTests(): void {
    enabled = false;
}
